import {createContext} from 'react'

interface TicketsDetailsContextType {
  setExpandedFormSubmit: (submitFn: () => void) => void
  resetExpandedFormSubmit: () => void
}

export const TicketsDetailsContext = createContext<TicketsDetailsContextType>({
  setExpandedFormSubmit: () => {},
  resetExpandedFormSubmit: () => {},
})
